module.exports = __webpack_public_path__ + "static/media/redeizee.aa840139.svg";